import * as React from "react";

const SyncQueuePage: React.FC<{ children?: React.ReactNode }> = (props) => (
  <div>{props.children}</div>
);

export default SyncQueuePage;
